module.exports = __webpack_public_path__ + "img/icono-experiencia-5.1c4e3dd8.svg";